import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import * as Sentry from "@sentry/react";
import mixpanel from "mixpanel-browser";
import { ErrorBoundary } from "react-error-boundary";
import App from "./App.tsx";
import GlobalErrorFallback from "./components/error/GlobalErrorFallback.tsx";
import "./index.css";
import "./lang/config.ts";

// Initialize Sentry for error tracking and performance monitoring
Sentry.init({
  dsn: "https://fa045f6837ec00e8bf56ff9723c10325@o4509909890629632.ingest.de.sentry.io/4510198858711120",
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  tracePropagationTargets: ["localhost", /^https:\/\/app-qa\.somsagt\.no/],
  sendDefaultPii: true,
  integrations: [Sentry.replayIntegration()],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

// Initialize Mixpanel for tracking events and custom events
const MIX_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN;
mixpanel.init(MIX_TOKEN, {
  autocapture: true,
  record_sessions_percent: 100,
  api_host: "https://api-eu.mixpanel.com",
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary
      FallbackComponent={GlobalErrorFallback}
      onError={(error, errorInfo) => {
        console.error("Global Error:", error, errorInfo);
      }}
      onReset={() => {
        window.location.href = "/";
      }}
    >
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
